(function(angular){
	'use strict';

	angular
		.module('formValidationModule')
		.directive('validatedInputField', [
			'STATIC_BASE_PATH',
			validatedInputFieldFunction
		]);

	function validatedInputFieldFunction(STATIC_BASE_PATH){
		return {
			restrict: 'E',
			templateUrl:  STATIC_BASE_PATH + '/static/html/shared/form-validation/form-field-directive.html',
			transclude: true,
			scope: {
				labelText: '@?',
				formType: '@?',
				invalidMessage: '@?',
				invalidMessageCustom: '@?',
				formField: '=',
				invalidCustomError: '@?'
			}
		};
	}
})(window.angular);